

import axios from "axios"
import router from "@/router/index.js"
import store from "@/store/index.js"
import NProgress from 'nprogress'

// const baseUrl = "http://192.168.1.203:8010/"  // 联调地址 
// const baseUrl = "http://172.16.100.33:8007/"  // 联调地址 
const baseUrl = migrate_ip //原始地址
// const baseUrl = "https://www.shooinsupport.com:6080/" //外网地址   
//   const baseUrl='http://192.168.125.116/'

const timeout = 30000
const useAjaxLoading = false
// $httpRequest
const http = (api, data, responseType, isDownloadFile, isLogin, isFormData) => {
	let opts = {
		url: baseUrl + api,
		method: responseType,
		timeout,
		headers: {
			token: !isLogin ? store.getters.getSessionId || JSON.parse(localStorage.getItem('loginSession')).sessionId : null
		}
	}

	if (isDownloadFile === true) {
		opts.responseType = "arraybuffer"
	}
	if (isFormData === true) {
		opts.headers['Content-Type'] = "multipart/form-data"
	}

	let test = /^http:\/\/.+$/
	if (test.test(api)) {
		opts.url = api
	}

	if (responseType === "post") {
		opts.data = data
	} else if (responseType === "get") {
		opts.params = data
	}

	return new Promise((resolve, reject) => {
		if (useAjaxLoading) {
			store.dispatch("set_loadding", true)
		} else {
			NProgress.start()
		}
		axios(opts).then(data => {
			if (useAjaxLoading) {
				store.dispatch("set_loadding", false)
			} else {
				NProgress.done()
			}
			let dataSource = data.data
			if (dataSource.code == 1000) {
				router.push({
					path: "/login"
				})
			} else {
				resolve(dataSource)
			}
		}).catch(err => {
			if (useAjaxLoading) {
				store.dispatch("set_loadding", false)
			} else {
				NProgress.done()
			}
			reject(err)
		})
	})
}

export {
	http,
	baseUrl
}
